import showEvent from './showEvent';
import initOffset from '../common/initOffset';

export default function initMassMedia() {
  initOffset(showEvent, '.js-events__offer-type-tag');
}
